/* From Parent theme */
import bootstrap from './core/bootstrap.js';
import chunks from './core/chunks.js';
import Lenis from 'lenis';

const App = {
    init() {
        // initialisation des événements et librairies globales
        bootstrap.init();

        // initialisation de Lenis pour smooth scrolling
        window.lenis = new Lenis({
            autoRaf: true,
        });

        // initialisation des scripts des différents modules / flexibles
        chunks.init();
    },
};

// Appel de la fonction d'initialisation
App.init();
